var Platform={OS:"web",select:obj=>"web"in obj?obj.web:obj.default,get isTesting(){return"test"===process.env.NODE_ENV}};export default Platform;